import { Box } from '@mui/material';
import Breadcrumbs from 'components/breadcrumbs';
import Paper from 'components/paper';
import PlaygroundTabsHeader from '../../../components/playground-tabs-header';
import FilterSidebar from 'components/filter-sidebar';
import SelectSite from './select-site';
import MySupplyPlanSitesSubTabs from 'views/order-feed/features/my-supply-plan/components/sites-sub-tabs';

import { useHistory, useParams } from 'react-router-dom';
import { useState, useMemo, useEffect } from 'react';

import { useSitesState } from 'views/order-feed/context/sites-context';
import { OrderFeedProvider } from 'views/order-feed/context/order-feed-context';
import SiteList from 'views/order-feed/features/my-supply-plan/components/site-list';
import { MySupplyPlanParams } from 'views/order-feed/features/my-supply-plan/types/my-supply-plan-params.type';

type Props = {};

const SitesOverview: React.FC<Props> = () => {
  const history = useHistory();
  const { siteTab } = useParams<MySupplyPlanParams>();

  const [selectedSiteId, setSelectedSiteId] = useState<string>('');

  const {
    sitesQuery: { data: sitesData },
  } = useSitesState();

  const { activeCount, inactiveCount } = useMemo(() => {
    const act = sitesData?.filter((s) => s.hasRecentOrders).length ?? 0;
    const inact = sitesData?.filter((s) => !s.hasRecentOrders).length ?? 0;
    return { activeCount: act, inactiveCount: inact };
  }, [sitesData]);

  const clearSelection = () => {
    setSelectedSiteId('');
    history.push('/playground/supply-plan/sites');
  };

  useEffect(() => {
    if (!siteTab) history.push('/playground/supply-plan/sites');
  }, [siteTab, history]);

  return (
    <>
      <PlaygroundTabsHeader utils={<Breadcrumbs />} />
      <Box>
        <FilterSidebar showClearFilter={!!selectedSiteId} clearFilters={clearSelection}>
          <SelectSite />
        </FilterSidebar>
      </Box>

      <MySupplyPlanSitesSubTabs aSites={activeCount} iSites={inactiveCount} />

      <Paper
        transparent
        sx={{
          display: 'flex',
          borderTopLeftRadius: { xs: 0, md: '1rem' },
          flexDirection: 'column',
          gap: 4,
        }}>
        <SiteList />
      </Paper>
    </>
  );
};

const SitesOverviewContainer: React.FC = () => (
  <OrderFeedProvider>
    <SitesOverview />
  </OrderFeedProvider>
);

export default SitesOverviewContainer;
